import { render, staticRenderFns } from "./Alert.vue?vue&type=template&id=5e64eea4&scoped=true"
import script from "./Alert.vue?vue&type=script&lang=js"
export * from "./Alert.vue?vue&type=script&lang=js"
import style0 from "./Alert.vue?vue&type=style&index=0&id=5e64eea4&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e64eea4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5e64eea4')) {
      api.createRecord('5e64eea4', component.options)
    } else {
      api.reload('5e64eea4', component.options)
    }
    module.hot.accept("./Alert.vue?vue&type=template&id=5e64eea4&scoped=true", function () {
      api.rerender('5e64eea4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/center-business/stock/consign/check/components/Alert.vue"
export default component.exports